import React from 'react'
import { connect } from 'react-redux'
import OkresSprawozdania from '../../components/DaneOrganizacyjne/OkresSprawozdania'
import InfoPanel from '../../components/InfoPanel'
import WykazOkresowSprawozdania from '../../components/OkresSprawozdawczy/WykazOkresowSprawozdania'
import { dateFromCalendar } from '../../lib/formatDateHandler'
import * as actions from '../../store/actions'
import MainStyle from '../../styles/MainStyle'

function OkresSprawozdawczy({
  onSetSectionDataArray,
  onSetSectionData,
  onSetDates,
  sectionList,
  validityErrors,
  dataWersjiOd,
  dataWersjiDo,
  dataSporzadzenia,
}) {
  function zauktualizujDaty(dataOd, dataDo) {
    sectionList.forEach((section, index) => {
      if (section.TypSekcji === 'WykazOkresowSprawozdania') {
        if (section.Dane && section.Dane.Pozycje && (section.Dane.Pozycje.length !== 0))
          section.Dane.Pozycje.forEach((x, index) => {
            onSetSectionDataArray(dateFromCalendar(dataOd), index, 1, 'DataOd')
            onSetSectionDataArray(dateFromCalendar(dataDo), index, 1, 'DataDo')
          })
      }
      else if (section.TypSekcji === 'WykazOkresowSprawozdania_v1_2') {
        onSetSectionData('DataOd', dateFromCalendar(dataOd), index)
        onSetSectionData('DataDo', dateFromCalendar(dataDo), index)
      }
    })
  }

  return (
    <MainStyle>
      <InfoPanel
        canExpand={false}
        rolledContent={
          <div>
            W tym miejscu należy wskazać okres objęty skonsolidowanym
            sprawozdaniem finansowym oraz datę sporządzenia sprawozdania. Należy
            też podać wykaz lat obrotowych lub okresów objętych sprawozdaniem
            finansowym jednostek powiązanych, jeżeli są one różne od okresu
            objętego skonsolidowanym sprawozdaniem finansowym..
          </div>
        }
      />
      {sectionList.map((data, sIndex) => {
        switch (data.TypSekcji) {
          case 'OkresSprawozdaniaSkrocona':
            return (
              <OkresSprawozdania
                key={sIndex}
                data={data.Dane}
                dataWersjiOd={dataWersjiOd}
                dataWersjiDo={dataWersjiDo}
                dataSporzadzenia={dataSporzadzenia}
                errors={validityErrors.filter(
                  value => value.TypSekcji === 'OkresSprawozdaniaSkrocona',
                )}
                onSetSectionData={(name, value) =>
                  onSetSectionData(name, value, sIndex)
                }
                onSetDates={(dataOd, dataDo) => {
                  onSetDates(dataOd, dataDo)
                  zauktualizujDaty(dataOd, dataDo)
                }}
              />
            )
          case 'WykazOkresowSprawozdania':
            return (
              <WykazOkresowSprawozdania
                key={sIndex}
                sIndex={sIndex}
                data={data.Dane}
                validityErrors={validityErrors.filter(
                  value => value.TypSekcji === 'WykazOkresowSprawozdania',
                )}
                onSetSectionDataArray={(v, i, n) =>
                  onSetSectionDataArray(v, i, sIndex, n)
                }
              />
            )

          case 'WykazOkresowSprawozdania_v1_2':
            return (
              <WykazOkresowSprawozdania
                key={sIndex}
                sIndex={sIndex}
                data={data.Dane}
                validityErrors={validityErrors.filter(
                  value => value.TypSekcji === 'WykazOkresowSprawozdania_v1_2',
                )}
                onSetSectionDataArray={(v, i, n) =>
                  onSetSectionDataArray(v, i, sIndex, n)
                }
              />
            )
          default:
            return null
        }
      })}
    </MainStyle>
  )
}

const mapStateToProps = state => ({
  validityErrors: state.sprawozdanie.validityErrors
    ? state.sprawozdanie.validityErrors
    : [],
  dataWersjiOd: state.sprawozdanie.header.DataWersjiOd,
  dataWersjiDo: state.sprawozdanie.header.DataWersjiDo,
  dataSporzadzenia: state.sprawozdanie.dataSporzadzenia,
})

const mapDispatchToProps = dispatch => ({
  onSetSectionDataArray: (v, index, sIndex, name) => {
    dispatch(actions.setSectionDataArray(v, index, sIndex, name))
  },
  onSetSectionData: (name, value, index) => {
    dispatch(actions.setSectionData(name, value, index))
  },
  onSetDates: (dateFrom, dateTo) => {
    dispatch(actions.setDates(dateFrom, dateTo))
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OkresSprawozdawczy)
